export interface TriboResumo {
  tribo_id: number;
  nome: string;
  cor: string | null;
  ordem: number;
  total: number;
  confirmados: number;
  homens: number;
  mulheres: number;
  idade_media: number | null;
  por_cidade: Record<string, number> | null;
}

export interface CampistaTribo {
  inscricao_id: number;
  nome: string;
  sexo: 'M' | 'F' | null;
  cidade: string | null;
  grupo: string | null;
  idade: number | null;
  situacao: string;
  tribo_id: number | null;
  status_tribo: 'sugerida' | 'confirmada' | null;
}

export interface DadosTribos {
  tribos: TriboResumo[];
  campistas: CampistaTribo[];
}

export interface FiltrosTribos {
  busca: string;
  sexo: '' | 'M' | 'F';
  cidade: string;
  soSem: boolean;
}

export const FILTROS_TRIBOS: FiltrosTribos = {
  busca: '',
  sexo: '',
  cidade: '',
  soSem: false,
};

export const ROTULO_SITUACAO: Record<string, string> = {
  pendente: 'Aguardando',
  confirmada: 'Confirmada',
  isenta: 'Isenta',
  lista_espera: 'Suplente',
  cancelada: 'Cancelada',
};

export function cidadesResumo(porCidade: Record<string, number> | null): string {
  if (!porCidade) return '';
  return Object.entries(porCidade)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3)
    .map(([cidade, n]) => `${cidade} ${n}`)
    .join(' · ');
}